//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import { mapGetters } from "vuex";

export default {
    name: "FabHeaderMenuActions",
    components: { AQTooltip },
    props: {
        mobile: { type: Boolean, default: false },
        sideBarPermissions: { type: Object, default: () => {} },
        isOwner: { type: Boolean, default: false }
    },
    computed: {
        ...mapGetters("diagrams", ["getHasNewComments"]),
        checkSidebarPermissions() {
            return this.sideBarPermissions.g && this.sideBarPermissions.g === "w";
        },
        hasDocumentsBtn() {
            return this.sideBarPermissions.DC && this.sideBarPermissions.DC.g === "w";
        },
        hasTimelineBtn() {
            return this.sideBarPermissions.TL && this.sideBarPermissions.TL.g === "w";
        },
        hasCommentsBtn() {
            return this.sideBarPermissions.CM && this.sideBarPermissions.CM.g === "w";
        },
        hasTaskInformationBtn() {
            return this.sideBarPermissions.ST && this.sideBarPermissions.ST.g === "w";
        }
    },
    methods: {
        emitEvent(eventType) {
            this.$emit("action", eventType);
        }
    }
};
